export {}

const toggleBtn = document.querySelectorAll(".f-inquiry__accessories-btn")
toggleBtn.forEach((btn) => {
  btn.addEventListener("click", () => {
    btn.classList.toggle("--open")
    btn.closest(".f-inquiry__accessories")?.classList.toggle("--open")
  })
})

// Modal source tracking
let modalSource: string | null = null

document.addEventListener("click", (event) => {
  const target = event.target as HTMLElement
  const button = target.closest("[data-modal-source]")

  if (button) {
    const source = button.getAttribute("data-modal-source")
    if (source) {
      modalSource = source
      const hiddenInput = document.getElementById("vehicle_inquiry_modal_source") as HTMLInputElement

      if (hiddenInput) {
        hiddenInput.value = source
      }
    }
  }
})

document.addEventListener("click", (event) => {
  const target = event.target as HTMLElement
  const modalButton = target.closest("[data-modal-target]")

  if (modalButton && modalSource) {
    const hiddenInput = document.getElementById("vehicle_inquiry_modal_source") as HTMLInputElement

    if (hiddenInput && modalSource) {
      hiddenInput.value = modalSource
    }
  }
})
